(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var root = document.querySelector('[data-ph-cart]');
  if (!root) return;
  var panel = root.querySelector('.ph-cart__panel');
  var body = root.querySelector('[data-ph-cart-body]');
  var foot = root.querySelector('[data-ph-cart-foot]');
  var subtotalEl = root.querySelector('[data-ph-cart-subtotal]');
  var headCount = root.querySelector('[data-ph-cart-headcount]');
  var srEl = root.querySelector('[data-ph-cart-sr]');
  var affirmEl = foot ? foot.querySelector('[data-ph-cart-affirm]') : null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;
  var currentCart = null, changing = false, closing = false, lineFocus = null;
  var errorEl = document.createElement('p'); errorEl.setAttribute('role', 'alert'); errorEl.hidden = true;
  errorEl.style.cssText = 'margin:12px 24px;color:var(--ph-ember)'; panel.insertBefore(errorEl, body);
  var retryButton = document.createElement('button'); retryButton.type = 'button'; retryButton.textContent = 'Refresh cart'; retryButton.hidden = true;
  panel.insertBefore(retryButton, body); retryButton.addEventListener('click', function () { refresh(); });
  function fail(error) { errorEl.textContent = error.message || 'Unable to update your cart. Please check the cart and try again.'; errorEl.hidden = false; }
  var currency = root.getAttribute('data-currency') || 'USD';
  var fmt;
  try { fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency }); } catch (e) { fmt = null; }
  function money(c) { return fmt ? fmt.format(c / 100) : '$' + (c / 100).toFixed(2); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  function sized(u, w) { return u ? (u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w) : ''; }
  function routeBase() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/'; }
  function announce(msg) { if (!srEl) return; srEl.textContent = ''; requestAnimationFrame(function () { srEl.textContent = msg; }); }
  function refreshAffirm() { try { if (window.affirm && window.affirm.ui && window.affirm.ui.refresh) window.affirm.ui.refresh(); } catch (e) {} }

  function setHeaderCount(n) {
    document.querySelectorAll('[data-ph-cart-count]').forEach(function (el) { el.textContent = n; el.classList.toggle('is-empty', n === 0); });
    if (headCount) headCount.textContent = n > 0 ? ' (' + n + ')' : '';
  }

  function itemHTML(it) {
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="ph-cart__ci-variant">' + esc(it.variant_title) + '</span>' : '';
    var img = it.image ? '<img src="' + sized(it.image, 160) + '" alt="" width="80" height="80" loading="lazy">' : '';
    return '<li class="ph-cart__ci" data-ph-ci data-key="' + it.key + '" data-variant-id="' + it.id + '" data-qty="' + it.quantity + '">'
      + '<a class="ph-cart__ci-media" href="' + it.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>'
      + '<div class="ph-cart__ci-info">'
      + '<a class="ph-cart__ci-title" href="' + it.url + '">' + esc(it.product_title) + '</a>' + variant
      + '<div class="ph-cart__ci-bottom">'
      + '<div class="ph-cart__ci-actions">'
      + '<div class="ph-cart__ci-qty">'
      + '<button type="button" data-ph-ci-dec aria-label="Decrease quantity"' + (it.quantity <= 1 ? ' disabled' : '') + '>'
      + '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" focusable="false"><path d="M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>'
      + '<span>' + it.quantity + '</span>'
      + '<button type="button" data-ph-ci-inc aria-label="Increase quantity">'
      + '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" focusable="false"><path d="M8 3v10M3 8h10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>'
      + '</div>'
      + '<button type="button" class="ph-cart__ci-remove" data-ph-ci-remove aria-label="Remove ' + esc(it.product_title).replace(/"/g, '&quot;') + '"><svg width="17" height="17" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M3.5 6h13M5.5 6v9.5a1.5 1.5 0 001.5 1.5h6a1.5 1.5 0 001.5-1.5V6M8 6V4.8a1 1 0 011-1h2a1 1 0 011 1V6" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 9v4.7M11.5 9v4.7" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg></button>'
      + '</div>'
      + '<span class="ph-cart__ci-price">' + money(it.final_line_price) + '</span>'
      + '</div>'
      + '</div></li>';
  }
  function emptyHTML() {
    return '<div class="ph-cart__empty">'
      + '<svg width="52" height="52" viewBox="0 0 40 40" fill="none" aria-hidden="true" focusable="false"><path d="M8 12h24l-2.5 15a2 2 0 01-2 1.7H12.5a2 2 0 01-2-1.7L8 12z" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"/><path d="M14 12a6 6 0 0112 0" stroke="currentColor" stroke-width="1.3"/></svg>'
      + '<p class="ph-cart__empty-title">Your cart is empty</p>'
      + '<a class="ph-btn ph-btn--ghost" href="' + routeBase() + 'collections/all-saunas" data-ph-cart-close>Shop saunas</a>'
      + '</div>';
  }
  function rememberLineFocus() {
    if (closing || root.getAttribute('data-open') !== 'true') return;
    var active = document.activeElement, line = active.closest && active.closest('[data-ph-ci]');
    if (!line || !body.contains(line)) return;
    var action = ['[data-ph-ci-inc]', '[data-ph-ci-dec]', '[data-ph-ci-remove]', '.ph-cart__ci-title'].find(function (selector) { return active.matches(selector); });
    if (action) lineFocus = { key: line.getAttribute('data-key'), action: action, index: Array.from(body.querySelectorAll('[data-ph-ci]')).indexOf(line) };
  }
  function restoreLineFocus() {
    if (!lineFocus || closing || root.getAttribute('data-open') !== 'true' || window.PHCartRequest.busy()) return;
    if (document.activeElement !== document.body && !body.contains(document.activeElement)) { lineFocus = null; return; }
    var lines = Array.from(body.querySelectorAll('[data-ph-ci]'));
    var line = lines.find(function (el) { return el.getAttribute('data-key') === lineFocus.key; }) || lines[Math.min(lineFocus.index, lines.length - 1)];
    var target = line && line.querySelector(lineFocus.action);
    if (!target || target.disabled) target = line && line.querySelector('button:not(:disabled), .ph-cart__ci-title');
    if (!target) target = panel.querySelector('button[data-ph-cart-close]');
    lineFocus = null;
    if (target) target.focus({ preventScroll: true });
  }
  document.addEventListener('ph:cart:pending', rememberLineFocus);
  document.addEventListener('ph:cart:settled', restoreLineFocus);
  document.addEventListener('focusin', function (event) { if (!body.contains(event.target)) lineFocus = null; });
  function render(cart) {
    rememberLineFocus();
    currentCart = cart;
    setHeaderCount(cart.item_count);
    if (cart.item_count === 0) { body.innerHTML = emptyHTML(); foot.hidden = true; }
    else {
      foot.hidden = false;
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
      if (affirmEl) affirmEl.setAttribute('data-amount', cart.total_price);
      body.innerHTML = '<ul class="ph-cart__list" role="list">' + cart.items.map(itemHTML).join('') + '</ul>';
      refreshAffirm();
    }
    window.PHCartRequest.syncControls();
    restoreLineFocus();
  }

  function fetchCart() {
    return window.PHCartRequest.request('cart.js', undefined, 'drawer');
  }
  function fresh(cart) { root.removeAttribute('data-ph-cart-stale'); retryButton.hidden = true; render(cart); window.PHCartRequest.syncControls(); }
  function refresh(clearError) { return fetchCart().then(function (cart) { if (clearError !== false) errorEl.hidden = true; return cart; }).catch(function (error) { fail(error); root.setAttribute('data-ph-cart-stale', 'true'); retryButton.hidden = false; window.PHCartRequest.syncControls(); return null; }); }
  document.addEventListener('ph:cart:state', function (event) { fresh(event.detail.cart); });

  var scrim = root.querySelector('.ph-cart__scrim');
  var G = window.gsap, animate = !!G && !reduce;

  function commit(key, qty, doPulse) {
    if (changing || window.PHCartRequest.busy()) return Promise.resolve(null);
    changing = true; errorEl.hidden = true;
    body.setAttribute('aria-busy', 'true');
    return window.PHCartRequest.request('cart/change.js', { id: key, quantity: qty }, 'drawer')
      .then(function (cart) {
        if (doPulse) pulseLine(key);
        var it = null; for (var i = 0; i < cart.items.length; i++) { if (cart.items[i].key === key) { it = cart.items[i]; break; } }
        if (it) announce('Quantity updated to ' + it.quantity + '. Subtotal ' + money(cart.total_price) + '.');
        return cart;
      })
      .catch(function (error) { fail(error); return null; })
      .finally(function () { changing = false; body.removeAttribute('aria-busy'); });
  }
  function change(key, qty) { commit(key, qty, qty > 0); }

  // Remove with a one-tap undo toast (single-item carts make an accidental remove costly).
  var undoTimer = null;
  function hideToast(toast) {
    if (!toast) return;
    if (animate) G.to(toast, { autoAlpha: 0, y: 12, duration: 0.2, ease: 'power2.in', onComplete: function () { toast.remove(); } });
    else toast.remove();
  }
  function showUndo(item, title, removedCart) {
    panel.querySelectorAll('.ph-cart__toast').forEach(function (old) { old.remove(); });
    var toast = document.createElement('div'), recoveryState = 'absent';
    toast.className = 'ph-cart__toast';
    toast.innerHTML = '<span>Removed ' + esc(title) + '.</span> <button type="button" data-ph-cart-undo>Undo</button>';
    panel.insertBefore(toast, foot);
    if (animate) G.fromTo(toast, { autoAlpha: 0, y: 12 }, { autoAlpha: 1, y: 0, duration: 0.26, ease: 'power2.out' });
    clearTimeout(undoTimer);
    undoTimer = setTimeout(function () { hideToast(toast); }, 6000);
    toast.querySelector('[data-ph-cart-undo]').addEventListener('click', function () {
      var button = toast.querySelector('button'); if (button.disabled) return; button.disabled = true;
      clearTimeout(undoTimer);
      window.PHCartRequest.recover(item, recoveryState === 'unknown', 'drawer', removedCart).then(function (result) {
        recoveryState = result.state;
        if (result.state === 'restored') {
          hideToast(toast); announce(title + ' restored.');
          if (!result.cart) { root.setAttribute('data-ph-cart-stale', 'true'); retryButton.hidden = false; fail(result.error); }
          else errorEl.hidden = true;
        } else {
          button.disabled = false;
          button.textContent = result.state === 'absent' ? 'Retry Undo' : 'Refresh cart';
          fail(result.error || new Error(result.state === 'absent' ? 'The item is still removed. You can retry Undo.' : 'We could not confirm the restored quantity. Refresh the cart before trying again.'));
          if (result.state === 'unknown') { root.setAttribute('data-ph-cart-stale', 'true'); retryButton.hidden = false; }
        }
        window.PHCartRequest.syncControls();
      });
    });
  }
  function removeItem(li) {
    var key = li.getAttribute('data-key');
    var item = currentCart && currentCart.items.find(function (x) { return x.key === key; });
    if (!item) return;
    var titleEl = li.querySelector('.ph-cart__ci-title');
    var title = titleEl ? titleEl.textContent.trim() : 'Item';
    commit(key, 0, false).then(function (cart) {
      if (cart && !cart.items.some(function (x) { return x.key === key; })) { announce('Removed ' + title + '.'); showUndo(item, title, cart); }
    });
  }
  // Quantity-change feedback: pulse + gold-flash the line price, and pulse the subtotal.
  function pulseLine(key) {
    if (!animate) return;
    var line = body.querySelector('[data-ph-ci][data-key="' + key + '"]');
    var price = line && line.querySelector('.ph-cart__ci-price');
    if (price) {
      G.fromTo(price, { scale: 1 }, { scale: 1.14, duration: 0.16, yoyo: true, repeat: 1, ease: 'power2.out', transformOrigin: 'right center' });
      /* Gold flash back to ink. Literals: #8A6A2F gold-ink, #15110D ink. */
      G.fromTo(price, { color: '#8A6A2F' }, { color: '#15110D', duration: 0.5, ease: 'power1.out' });
    }
    if (subtotalEl) G.fromTo(subtotalEl, { scale: 1 }, { scale: 1.08, duration: 0.16, yoyo: true, repeat: 1, ease: 'power2.out', transformOrigin: 'right center' });
  }

  /* Delegated line-item controls (items are re-rendered). */
  body.addEventListener('click', function (e) {
    var li = e.target.closest('[data-ph-ci]');
    if (!li) return;
    if (changing || window.PHCartRequest.busy() || root.hasAttribute('data-ph-cart-stale')) return;
    var key = li.getAttribute('data-key'), qty = parseInt(li.getAttribute('data-qty'), 10);
    // floor at 1: a mis-tap on minus must never silently delete the line;
    // removal is only via the explicit Remove control
    if (e.target.closest('[data-ph-ci-dec]')) change(key, Math.max(1, qty - 1));
    else if (e.target.closest('[data-ph-ci-inc]')) change(key, qty + 1);
    else if (e.target.closest('[data-ph-ci-remove]')) removeItem(li);
  });

  /* Open / close: GSAP with a staggered scrim + panel and an expo ease; reduced
     motion (or no GSAP) sets the final state instantly. */
  function open() {
    closing = false;
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    errorEl.hidden = true;
    var refreshed = refresh();
    if (animate) {
      G.killTweensOf([scrim, panel]);
      var tl = G.timeline();
      tl.fromTo(scrim, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.3, ease: 'power2.out' }, 0);
      tl.fromTo(panel, { x: '100%' }, { x: '0%', duration: 0.55, ease: 'expo.out' }, 0.08);
      // once line items render, rise them in with a small stagger
      refreshed.then(function () {
        var items = panel.querySelectorAll('.ph-cart__ci');
        if (items.length) G.fromTo(items, { y: 12, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: 0.32, stagger: 0.05, ease: 'power2.out', delay: 0.12, clearProps: 'transform,opacity' });
      });
    } else if (G) { G.set(scrim, { autoAlpha: 1 }); G.set(panel, { x: '0%' }); }
    else { scrim.style.opacity = '1'; panel.style.transform = 'translateX(0)'; }
    if (panel && !releaseCartModal) releaseCartModal = PHModal.open(root, panel, close, lastFocus);
  }
  function finishClose() {
    if (releaseCartModal) { releaseCartModal(); releaseCartModal = null; }
    root.removeAttribute('data-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function close() {
    if (root.getAttribute('data-open') !== 'true') return;
    closing = true; lineFocus = null;
    if (animate) {
      G.killTweensOf([scrim, panel]);
      var tl = G.timeline({ onComplete: finishClose });
      tl.to(panel, { x: '100%', duration: 0.4, ease: 'power3.in' }, 0);
      tl.to(scrim, { autoAlpha: 0, duration: 0.3, ease: 'power2.in' }, 0.1);
    } else {
      if (G) { G.set(scrim, { autoAlpha: 0 }); G.set(panel, { x: '100%' }); } else { scrim.style.opacity = '0'; panel.style.transform = 'translateX(100%)'; }
      finishClose();
    }
  }
  root.addEventListener('click', function (e) { if (e.target.closest('[data-ph-cart-close]')) close(); });
  var releaseCartModal = null;

  /* Hijack the header cart icon(s) to open the drawer (still a real /cart link with no JS). */
  document.querySelectorAll('.ph-header__cart').forEach(function (link) {
    link.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });

  document.addEventListener('cart:refresh', function () { refresh(false); });
  window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(false); });
  window.addEventListener('focus', function () { if (root.getAttribute('data-open') === 'true') refresh(false); });

  window.PHCart = { open: open, close: close, refresh: refresh };

  /* Prime the drawer contents so the first open is instant. */
  refresh();
})();
  } catch(e) { console.error(e); }
})();

})();
